<aside
    class="flex min-w-0 items-center gap-2 rounded-[var(--qpx-radius-sm)] bg-primary-muted p-2 text-primary-muted"
    role="note"
>
    <qpx-hero-icon
        name="lucideInfo"
        context="primary"
        [active]="true"
        class="shrink-0"
    />
    <span qpxBody="accent" size="md"
        >Review the changes before creating the pack.</span
    >
</aside>
<footer>
    <div class="flex justify-end gap-1">
        <button
            qpxButton
            matButton="outlined"
            size="sm"
            (click)="editClicked.emit()"
        >
            <ng-icon qpx size="sm" name="lucidePencil" matButtonIcon /><span
                >Edit details</span
            >
        </button>
        <button
            qpxButton
            matButton="filled"
            context="primary"
            size="sm"
            (click)="applyClicked.emit()"
        >
            <ng-icon qpx size="sm" name="lucideCheck" matButtonIcon /><span
                >Create pack</span
            >
        </button>
    </div>
</footer>
